import { Plugin } from 'hubspot-prosemirror/pm/state';
import ReactDOM from 'react-dom';
import { getMarkRange } from '../../utils/markUtils';
import LinkContent from './LinkContent';
import { getActiveLinkMark, getLinkAttrs, getLinkText } from './LinkUtils';
import { jsx as _jsx } from "react/jsx-runtime";
class LinkPopup {
  constructor(view) {
    this.tooltip = document.createElement('div');
    this.createTooltip(view);
    this.update(view, null);
  }
  createTooltip(view) {
    this.tooltip = document.createElement('div');
    this.tooltip.style.display = 'none';
    this.tooltip.className = 'tooltip';
    view.dom.parentNode.appendChild(this.tooltip);
  }
  update(view, lastState) {
    const pluginState = LinkPlugin.getState(view.state); // eslint-disable-line @typescript-eslint/no-use-before-define
    const lastPluginState = lastState && LinkPlugin.getState(lastState); // eslint-disable-line @typescript-eslint/no-use-before-define
    if (pluginState && pluginState.showTooltip && pluginState.activeMark) {
      if (lastPluginState && pluginState && lastPluginState.target === pluginState.target) {
        return;
      }
      if (lastPluginState && lastPluginState.showTooltip) {
        ReactDOM.unmountComponentAtNode(this.tooltip);
        this.tooltip.remove();
        this.createTooltip(view);
      }
      this.tooltip.style.display = '';
      const linkText = getLinkText(view.state.doc, pluginState.markBounds);
      const linkAttrs = getLinkAttrs(view.state, pluginState.markBounds);
      if (linkAttrs) {
        ReactDOM.render( /*#__PURE__*/_jsx(LinkContent, {
          initialText: linkText,
          initialHref: linkAttrs.href,
          initialTarget: linkAttrs.isTargetBlank,
          editorView: view,
          markBounds: pluginState.markBounds,
          target: pluginState.target,
          paymentLinkReferrer: pluginState.paymentLinkReferrer || undefined
        }), this.tooltip);
      }
    } else {
      ReactDOM.unmountComponentAtNode(this.tooltip);
      this.tooltip.style.display = 'none';
    }
  }
  destroy() {
    ReactDOM.unmountComponentAtNode(this.tooltip);
    this.tooltip.remove();
  }
}
export const initialState = {
  showTooltip: false,
  activeMark: null,
  markBounds: null,
  target: null,
  keyComboFired: false,
  paymentLinkReferrer: null
};
export const LinkPlugin = new Plugin({
  state: {
    init() {
      return initialState;
    },
    apply(tr, old) {
      const meta = tr.getMeta(LinkPlugin);
      if (meta) {
        return meta;
      }
      const newState = Object.assign({}, old, {
        showTooltip: false,
        keyComboFired: false
      });
      return tr.docChanged ? newState : old;
    }
  },
  props: {
    handleClick: (view, _pos, event) => {
      if (!view.editable) {
        return false;
      }
      const {
        target
      } = event;
      const tr = view.state.tr;
      if (target) {
        const hyperlinkElement = target.closest(`a`);
        const {
          $cursor
        } = view.state.selection;
        if (hyperlinkElement && $cursor) {
          const activeMark = getActiveLinkMark(view.state);
          const pluginState = LinkPlugin.getState(view.state);
          if (activeMark) {
            const markBounds = getMarkRange($cursor, activeMark);
            if (pluginState.showTooltip && markBounds && pluginState.markBounds.from === markBounds.from && pluginState.markBounds.to === markBounds.to) {
              tr.setMeta(LinkPlugin, initialState);
              tr.setMeta('addToHistory', false);
              view.dispatch(tr);
            } else {
              tr.setMeta(LinkPlugin, {
                showTooltip: true,
                activeMark,
                markBounds,
                paymentLinkReferrer: pluginState.paymentLinkReferrer,
                target: hyperlinkElement
              });
              tr.setMeta('addToHistory', false);
              view.dispatch(tr);
            }
            return true;
          }
        }
      }
      tr.setMeta(LinkPlugin, initialState);
      tr.setMeta('addToHistory', false);
      view.dispatch(tr);
      view.focus();
      return false;
    }
  },
  view(editorView) {
    return new LinkPopup(editorView);
  }
});